module.exports = __webpack_public_path__ + "d6fda81d25083d578b2ad1d0e0c7ccde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamps/animal-kawauso-isogimasu.png
// module id = 2087
// module chunks = 4